import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import { getInitials } from "@/components/ArticleContent/components/Byline/utilities/byline-utils";
type AuthorImagePlaceholderProps = {
  readonly className?: string;
  readonly fullName: string;
};
export function AuthorImagesPlaceholder(t0) {
  const $ = _c(9);
  const {
    className,
    fullName
  } = t0;
  let t1;
  if ($[0] !== fullName) {
    t1 = getInitials(fullName);
    $[0] = fullName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initials = t1;
  let t2;
  if ($[2] !== className) {
    t2 = clsx("flex size-6 items-center justify-center rounded-full bg-whisper", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== initials) {
    t3 = <span className="font-theme-bold text-nobel text-sm">{initials}</span>;
    $[4] = initials;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}